import { UploadedFiles } from '@core/data-access/models/file-upload.model';
import { CheckboxFormField, FileUploadFormField, FormField } from '@core/data-access/models/form/form-store.model';
import { isArray, isDate, isObject } from 'lodash';

export const isFormField = (formField: FormField | CheckboxFormField | FileUploadFormField): formField is FormField =>
  typeof formField.value === 'string' || typeof formField.value === 'boolean' || isDate(formField.value);

export const isCheckboxFormField = (
  formField: FormField | CheckboxFormField | FileUploadFormField
): formField is CheckboxFormField => isCheckboxFormFieldValue(formField.value);

export const isCheckboxFormFieldValue = (value: string | number | boolean | object | Date | UploadedFiles) =>
  !isArray(value) && isObject(value) && !isDate(value);
